import React from 'react';
import styled from 'styled-components';

import { Col, Separator } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';

const Column = styled(Col)`
  margin-bottom: ${({ mBottom }) => mBottom}px;
`;

const Title = styled(Text)`
  border-bottom: 2px solid;
  width: max-content;
  text-transform: capitalize;
`;

const MAP = {
  event: 'event name',
  within_campaign_lifetime: 'During campaign life',
  true: 'Yes',
  false: 'No',
};

const ReferralTrackedEvents = ({ trackedEvents }) => {
  return (
    <>
      {Object.entries(trackedEvents)?.map(([key, value], i) => {
        return (
          <Column mBottom={24} key={key}>
            <Title variant="h4">{key}</Title>
            <Separator height={16} transparent />
            {value?.map((el, j) => {
              return (
                <Column mBottom={24} gutter={0} key={`${key}-${i}-${j}`}>
                  {Object.entries(el)?.map(([l, m], k) => {
                    return (
                      <Column mBottom={4} key={`${l}-${i}-${j}-${k}`}>
                        <Text variant="eyebrow2">{MAP[l] || l}</Text>
                        <Text variant="h6">{MAP[m] || m}</Text>
                      </Column>
                    );
                  })}
                </Column>
              );
            })}
          </Column>
        );
      })}
    </>
  );
};

export default ReferralTrackedEvents;
